export default __webpack_public_path__ + "static/media/ic_next.9e1e0ebf.svg";